import React from "react";
import { BacklinkInfo, getAllBacklinks } from "../Utilities/BusinessTypeUtils"

const linkStyle = { fontFamily: 'proxima-nova', fontSize: "12px", fontWeight: "400", lineHeight: "15px" };

export default function RenderBackLinks({ data, cid }: { data: any, cid: number|undefined }) {



    let countryID = cid??1;
    let locale = "";
    switch (countryID) {
        case 2:
            locale = "en-gb/";
            break;
        case 3:
            locale = "en-ca/";
            break;
        case 4:
            locale = "en-au/";
            break;
        default:
            break;
    }

    if (countryID !== 1) {

        let poweredByVagaro = document.querySelector(".render [href='https://www.vagaro.com/pro/booking-website-builder']");
        if (poweredByVagaro) {
            poweredByVagaro.setAttribute("href", `https://www.vagaro.com/${locale}pro/booking-website-builder`);
        }
    }


    let backLinks: BacklinkInfo[] = getAllBacklinks(data?.["Business Type"], locale);

    return <>
        {backLinks.length > 0 && backLinks.map((link, index) => (
            (!link.url || link.url.length < 1) ? null : <span key={link.url} style={linkStyle}>,{" "}<a className="no-a inherit-color" href={link.url} rel="noreferrer" target="_blank" data-vagaro-backlink>{link.label}</a></span>



        ))}
    </>

}